import React, {useEffect, useState} from 'react'
import axios from './axios'
import requests from './requests'
import './index.css'

const Banner = ({title,fetchUrl}) => {
    const [movie,setMovie]=useState([]);
    useEffect(() => {
        async function getData(){
            const request= await axios.get(fetchUrl)
            setMovie(request.data.results[Math.floor(Math.random()*request.data.results.length-1)])
        
        return request;
        }
     getData()
    }, [])

    function truncate(str, n){
        return str?.length > n ? str.substr(0, n-1) + "..." : str;
    }
    return (
       <header className = "banner"
            style={{
                backgroundSize: "cover",
                backgroundImage: `url("https://image.tmdb.org/t/p/original${movie?.backdrop_path}")`,
                backgroundPosition: "center center"
            }}
        >
            <div className = "banner_contents">
                <h1 className = "banner_title" style={{color:"#d6ed17ff"}}>
                    {movie?.title || movie.name || movie?.orignal_name}
                </h1>
                <div className="Banner_btn">
                    <button className="btn">Play</button>
                    <button className="btn">List</button>

                </div>
                <h1 className="banner_overview">{truncate(movie?.overview,200)}</h1>
                </div>
               <div className="fade"></div>
       </header>
    )
}
export default Banner